import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { shiftPatternsApi } from "../api/shiftPatternsApi";
import { invalidateShiftQueries } from "../../plantoes/hooks/invalidateShiftQueries";

// Lista e prévia ficam sob a mesma raiz de chave: mudar uma regra invalida as duas.
const ROOT_KEY = "shift-patterns";

export function useShiftPatternsQuery(vinculoId) {
  return useQuery({
    queryKey: [ROOT_KEY, "vinculo", String(vinculoId)],
    queryFn: () => shiftPatternsApi.listByVinculo(vinculoId),
    enabled: Boolean(vinculoId),
  });
}

export function useShiftPatternPreviewQuery({ year, month }, { enabled = true } = {}) {
  return useQuery({
    queryKey: [ROOT_KEY, "preview", { year, month }],
    queryFn: () => shiftPatternsApi.preview({ year, month }),
    enabled,
  });
}

export function useCreateShiftPatternMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: shiftPatternsApi.create,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ROOT_KEY] }),
  });
}

export function useDeleteShiftPatternMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: shiftPatternsApi.remove,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [ROOT_KEY] }),
  });
}

// Gerar a escala cria plantões: tudo o que depende de plantões muda, inclusive a prévia
// (invalidateShiftQueries já cobre "shift-patterns").
export function useGenerateScheduleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: shiftPatternsApi.generate,
    onSuccess: () => invalidateShiftQueries(queryClient),
  });
}
